import { snakeCase, reduce } from 'lodash';

export function getActualFilters(refinement, excludedKeys = []) {
    const filters = {};
    Object.keys(refinement).forEach((key) => {
        if (!excludedKeys.includes(key)) {
            const value = refinement[key];
            if (value || value === 0) {
                filters[key] = value;
            }
        }
    });
    return filters;
}

export function getRefinementQueryParam(
    refinement,
    excludedKey,
    actualFiltersGetter = getActualFilters
) {
    return reduce(
            actualFiltersGetter(refinement, excludedKey),
            (obj, value, key) => Object.assign({
                [snakeCase(key)]: value
            }, obj),
            {}
        );
}

export function getQueryParams(
    refinement,
    page,
    excludedKey,
    actualFiltersGetter
) {
    return {
        page,
        refine: getRefinementQueryParam(refinement, excludedKey, actualFiltersGetter)
    };
}



// WEBPACK FOOTER //
// ./src/js/helpers/refinementUtils.js